import useWebsiteSettings from './useWebsiteSettings';

export default function useRevieveSettings() {
    const { revieve } = useWebsiteSettings();
    return revieve;
}
